import { useTranslation } from "react-i18next";
import { Dialog } from "../ui/Dialog/Dialog";

interface WhatsNewModalProps {
  onClose: () => void;
}

/**
 * "What's new" announcement, shown once per app version (gated in
 * Page.tsx). Uses the shared Sharp `Dialog` primitive (focus trap,
 * ESC, scroll-lock, createPortal) like every other dialog — it was
 * the last `react-modal` holdout before this conversion.
 */
export default function WhatsNewModal({ onClose }: WhatsNewModalProps) {
  const { t } = useTranslation("common");
  const features = t("whatsNew.features", { returnObjects: true }) as string[];

  return (
    <Dialog open onClose={onClose} variant="modal" className="whats-new">
      <Dialog.Header>
        <h2 className="whats-new-title">{t("whatsNew.heading")}</h2>
      </Dialog.Header>
      <Dialog.Body>
        <ul className="whats-new-list">
          {features.map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
        <button type="button" className="whats-new-cta" onClick={onClose}>
          {t("whatsNew.cta")}
        </button>
      </Dialog.Body>
    </Dialog>
  );
}
